<template>
  <div>
    <b-card class="m-3">
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold"
            >Cadastrar nova vaga</span
          >
          <btn-voltar />
        </h6>
      </template>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(salvarCargo)">
          <b-row>
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                v-slot="defaultState"
                rules="required"
                label="Código"
              >
                <b-form-input
                  v-model="cargo.codigoCargo"
                  id="input-codigo"
                  :state="defaultState.state"
                  type="text"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="Vínculo"
              >
                <b-form-select
                  id="input-vinculo"
                  :state="defaultState.state"
                  v-model="cargo.vinculo"
                  :options="tiposVinculo"
                  @change="handleVinculoChange"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="Nomenclatura"
              >
                <b-form-input
                  v-if="nomenclaturaTextoLivre"
                  v-b-tooltip.click.bottom
                  v-b-tooltip.blur.bottom
                  title="Igual ao Normativo"
                  id="input-nomenclatura"
                  v-model="nomenclaturaInput"
                  :state="defaultState.state"
                  type="text"
                  :disabled="cargo.vinculo == null"
                  @blur="verificarNomenclatura(nomenclaturaInput)"
                />
                <b-form-select
                  v-else
                  id="select-nomenclatura"
                  :state="defaultState.state"
                  v-model="cargo.nomenclaturaCargo"
                  :options="tiposNomenclatura"
                  :disabled="cargo.vinculo == null"
                  @input="verificarNomenclatura(cargo.nomenclaturaCargo)"
                >
                </b-form-select>
              </default-form-validation-provider>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="Situação da Vaga"
              >
                <b-form-select
                  id="input-situacao"
                  :state="defaultState.state"
                  v-model="cargo.situacaoCargo"
                  :options="tiposSituacao"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="Escolaridade Exigida"
              >
                <b-form-select
                  id="input-escolaridade"
                  :state="defaultState.state"
                  v-model="cargo.escolaridade"
                  :options="tiposEscolaridade"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="Quantidade de Vagas Existentes"
              >
                <b-form-input
                  id="input-quantidadeVagas"
                  v-model="cargo.quantidadeVagas"
                  :state="
                    defaultState.state &&
                    !isNaN(
                      parseInt(
                        cargo.quantidadeVagas.toString().replace('.', '')
                      )
                    )
                  "
                  type="text"
                  @change="checkNumeroDeVagas()"
                />
              </default-form-validation-provider>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="Regime Jurídico"
              >
                <b-form-select
                  id="input-regimeJuridico"
                  :state="defaultState.state"
                  v-model="cargo.regimeJuridico"
                  :options="tiposRegimeJuridico"
                  :disabled="cargo.vinculo == null"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="Natureza"
              >
                <b-form-select
                  id="input-naturezaCargo"
                  :state="defaultState.state"
                  v-model="cargo.naturezaCargo"
                  :options="tiposNatureza"
                  :disabled="cargo.vinculo == null"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="Regime Previdenciário"
              >
                <b-form-select
                  id="input-regimePrevidenciario"
                  :state="defaultState.state"
                  v-model="cargo.regimePrevidenciario"
                  :options="tiposRegimePrevidenciario"
                />
              </default-form-validation-provider>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="12" md="12" lg="8" xl="4">
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="A vaga possui normativo?"
              >
                <b-form-select
                  id="input-flPossuiNormativo"
                  :state="defaultState.state"
                  v-model="flPossuiNormativoSelecionado"
                  :options="optionsNormativo"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col
              v-if="mostrarInputCargaHoraria"
              sm="12"
              md="12"
              lg="8"
              xl="4"
            >
              <default-form-validation-provider
                rules="required"
                v-slot="defaultState"
                label="Carga Horária Semanal"
              >
                <b-form-input
                  id="input-cargaHoraria"
                  :state="defaultState.state"
                  v-model="cargo.cargaHoraria"
                  type="number"
                  min="1"
                  max="70"
                />
              </default-form-validation-provider>
            </b-col>
          </b-row>
          <br /><br />
          <b-row>
            <b-col sm="12" md="12" lg="8" xl="4" class="addNormativoBtnWrapper">
              <b-button
                v-if="flPossuiNormativoSelecionado == 'S'"
                :disabled="temNormativo"
                @click="$bvModal.show('modal')"
              >
                <font-awesome-icon icon="plus" class="mr-2" />Adicionar
                Normativo
              </b-button>
            </b-col>
          </b-row>
          <br /><br />
          <div v-if="temNormativo" id="infoNormativoWrapper">
            <span><b>Informações do normativo</b></span>
            <b-alert
              v-if="normativoNaoEncontrado"
              show
              dismissible
              variant="warning"
              ><strong>Atenção! </strong>Ato Normativo não encontrado na base de
              dados. Para cadastrar um novo Ato Normativo, clique
              <button
                type="button"
                class="btnCadastroLegislacoes"
                @click="$bvModal.show('modal-cadastro-legislacao')"
              >
                aqui
              </button></b-alert
            >
            <b-table
              :fields="camposNormativoAdicionado"
              striped
              hover
              no-border-collapse
              :items="normativoAdicionado"
              :busy="normativoAdicionado.length < 1"
            >
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(actions)="">
                <div v-if="false">
                  <span class="">{{}}</span>
                </div>
                <div v-else class="actions-icons">
                  <div
                    class="wrapper-icon"
                    @click="limparInformacoesNormativo()"
                  >
                    <font-awesome-icon icon="trash" />
                    <div style="font-size: 12px">Excluir</div>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
          <b-row>
            <b-col>
              <b-button type="submit">
                <font-awesome-icon icon="save" class="mr-2" />Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>

    <modal-adicionar-normativo
      :tiposAtoNormativo="tiposAtoNormativo"
      :tiposVeiculoPublicacao="tiposVeiculoPublicacao"
      @salvar="salvarNormativo"
    />
    <modal-cadastro-legislacao @fechar="fecharModalLegislacoes" />
    <modal-nomenclatura-duplicada @sair="$router.go(-1)" />
  </div>
</template>

<script lang="ts">
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import cargoService from "@/services/atos-pessoal/cargoService";
import {
  carregarTipoVinculo,
  carregarTipoRegimeJuridico,
  carregarTipoRegimePrevidenciario,
  carregarTipoNatureza,
  carregarTipoEscolaridade,
  carregarTipoSituacao,
  carregarTipoAtoNormativo,
  carregarTipoVeiculoPublicacaoNormativo,
} from "./utils";
import { store } from "@/store";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import { UtilsTS } from "@/utilsts";
import ModalAdicionarNormativo from "@/components/atos-pessoal/cargos/ModalAdicionarNormativo.vue";
import ModalCadastroLegislacao from "@/components/atos-pessoal/cargos/ModalCadastroLegislacao.vue";
import ModalNomenclaturaDuplicada from "@/components/atos-pessoal/cargos/ModalNomenclaturaDuplicada.vue";
import { Component, Ref, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { fieldsNormativoAdicionado } from "@/types/atos-pessoal/cargos/fields-normativo-adicionado";
import { SelectValue } from "@/types/select-value";
import { CargoCriar } from "@/types/atos-pessoal/cargos/cargo-criar";
import { TabelasAuxiliaresCargo } from "@/types/atos-pessoal/cargos/tabelas-auxiliares-cargo";

const ComProps = Vue.extend({
  name: "CriarCargo",
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
    BtnVoltar,
    ModalAdicionarNormativo,
    ModalCadastroLegislacao,
    ModalNomenclaturaDuplicada,
  },
});

@Component
export default class CriarCargo extends mixins(UtilsTS, ComProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;

  flPossuiNormativoSelecionado: "S" | "N" | null = null;
  optionsNormativo = [
    { text: "SELECIONE", value: null, disabled: true },
    { text: "SIM", value: "S" },
    { text: "NÃO", value: "N" },
  ];

  tabelasAuxiliares = new TabelasAuxiliaresCargo();
  tiposVinculo: SelectValue[] = [];
  tiposNomenclatura: SelectValue[] = [];
  nomenclaturaInput = "";
  tiposRegimeJuridico: SelectValue[] = [];
  tiposRegimePrevidenciario: SelectValue[] = [];
  tiposNatureza: SelectValue[] = [];
  tiposEscolaridade: SelectValue[] = [];
  tiposSituacao: SelectValue[] = [];
  tiposAtoNormativo: SelectValue[] = [];
  tiposVeiculoPublicacao: SelectValue[] = [];
  cargo = new CargoCriar();
  temNormativo = false;
  normativoNaoEncontrado = false;

  normativoAdicionado = [
    {
      numeroNormativo: "",
      anoNormativo: "",
      veiculoNormativo: "",
      dtInicioVigenciaNormativo: "",
      tipoNormativo: "",
    },
  ];

  nomenclaturaTextoLivre = false;

  camposNormativoAdicionado: TableField[] = fieldsNormativoAdicionado;

  async carregarTabelasAuxiliares() {
    const response = await cargoService.getTabelasAuxiliares();
    this.tabelasAuxiliares = response.data;
  }

  atualizarInformacoesNormativo() {
    const descricaoTipoAtoNormativo =
      this.cargo.normativo.tipoAtoNormativo != null
        ? this.formatTipoAtoNormativo(this.cargo.normativo.tipoAtoNormativo)
        : undefined;
    this.normativoAdicionado = [];
    this.normativoAdicionado.push({
      numeroNormativo:
        this.cargo.normativo.numeroAtoNormativo != null
          ? String(this.cargo.normativo.numeroAtoNormativo)
          : "",
      anoNormativo:
        this.cargo.normativo.anoAtoNormativo != null
          ? String(this.cargo.normativo.anoAtoNormativo)
          : "",
      veiculoNormativo: this.cargo.normativo.veiculoPublicacao,
      dtInicioVigenciaNormativo: this.formatData(
        this.cargo.normativo.dataInicioVigencia ?? ""
      ),
      tipoNormativo: descricaoTipoAtoNormativo ?? "",
    });
  }

  limparInformacoesNormativo() {
    this.normativoAdicionado = [];
    this.cargo.normativo.numeroAtoNormativo = "";
    this.cargo.normativo.anoAtoNormativo = "";
    this.cargo.normativo.veiculoPublicacao = "";
    this.cargo.normativo.dataInicioVigencia = "";
    this.cargo.normativo.tipoAtoNormativo = null;
    this.temNormativo = false;
  }

  async salvarNormativo(dados) {
    this.cargo.normativo.tipoAtoNormativo = dados.tipoAtoNormativo;
    this.cargo.normativo.veiculoPublicacao = dados.veiculoPublicacao;
    this.cargo.normativo.numeroAtoNormativo = dados.numeroAtoNormativo;
    this.cargo.normativo.anoAtoNormativo = dados.anoAtoNormativo;
    this.cargo.normativo.dataInicioVigencia = dados.dataInicioVigencia;
    this.atualizarInformacoesNormativo();
    this.temNormativo = true;
    this.$bvModal.hide("modal");

    const response = await cargoService.verificarNormativo(
      this.cargo.normativo.numeroAtoNormativo,
      this.cargo.normativo.anoAtoNormativo,
      dados.tipoAtoNormativo
    );
    this.normativoNaoEncontrado =
      response && response.status != 200 ? true : false;
  }

  async salvarCargo() {
    try {
      this.cargo.quantidadeVagas = this.cargo.quantidadeVagas
        .toString()
        .replace(".", "");
      this.cargo.possuiNormativo = this.flPossuiNormativoSelecionado ?? "N";

      if (this.nomenclaturaTextoLivre)
        this.cargo.nomenclaturaCargo = this.nomenclaturaInput;

      const cargoParaEnviar: any = { ...this.cargo };
      if (!this.temNormativo) delete cargoParaEnviar.normativo;

      const response = await cargoService.salvarCargo(cargoParaEnviar);
      if (response && response.status == 200) {
        this.$toast.success("Cargo salvo com sucesso");
        this.$router.push("/atos-pessoal/cargos/consulta");
      } else if (response && response.data?.erros) {
        response.data.erros.forEach((erro: string) => this.$toast.error(erro));
      } else {
        this.$toast.error("Erro ao salvar os dados");
      }
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  formatTipoAtoNormativo(idTipo: number) {
    const tipoAtoNormativo = this.tiposAtoNormativo.find(
      (t) => t.value == idTipo
    );
    if (tipoAtoNormativo?.text) return tipoAtoNormativo?.text;
    this.$toast.error("Erro ao formatar tipo de ato normativo");
  }

  async handleVinculoChange() {
    this.nomenclaturaInput = "";
    this.cargo.nomenclaturaCargo = "";
    this.nomenclaturaTextoLivre = this.cargo.vinculo
      ? [3, 4, 5, 8, 9, 13].includes(this.cargo.vinculo)
      : false;

    if (!this.nomenclaturaTextoLivre) {
      const nomenclaturas = this.tabelasAuxiliares.nomenclaturas.filter(
        (n) => n.IdVinculo == this.cargo.vinculo
      );
      const opcoes = nomenclaturas.map((n) => {
        return {
          value: n.Descricao,
          text: n.Descricao,
        };
      });
      this.tiposNomenclatura = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...opcoes,
      ];
    }

    //Tipo Vinculo 12 = MILITAR
    if (
      this.cargo.vinculo == 12 ||
      (this.cargo.vinculo == 4 &&
        (store.codigoUG == "001111" || store.codigoUG == "002213"))
    ) {
      const naturezas = this.tabelasAuxiliares.tipoNatureza.filter(
        (n) => n.Descricao == "MILITAR"
      );
      this.tiposNatureza = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...naturezas.map((n) => {
          return {
            value: n.Id,
            text: n.Descricao,
          };
        }),
      ];
    } else {
      const naturezas = this.tabelasAuxiliares.tipoNatureza.filter(
        (n) => n.Descricao != "MILITAR"
      );
      this.tiposNatureza = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...naturezas.map((n) => {
          return {
            value: n.Id,
            text: n.Descricao,
          };
        }),
      ];
    }
    const response = await cargoService.buscarRegimesJuridicos(
      this.cargo.vinculo
    );
    if (response && response.status == 200) {
      this.tiposRegimeJuridico = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...response.data.regimesJuridicos.map((n) => {
          return {
            value: n.IdTipoRegimeJuridico,
            text: n.DeTipoRegimeJuridico,
          };
        }),
      ];
    } else {
      this.$toast.error("Erro ao buscar regimes jurídicos");
    }

    if (!this.mostrarInputCargaHoraria) this.cargo.cargaHoraria = null;
  }

  checkNumeroDeVagas() {
    let min = 1;
    let max = 99999;
    const qntdVagasInt = parseInt(
      this.cargo.quantidadeVagas.toString().replace(".", "")
    );

    if (qntdVagasInt > max) this.cargo.quantidadeVagas = String(max);
    if (qntdVagasInt < min) this.cargo.quantidadeVagas = String(min);

    let rx = /(\d+)(\d{3})/; // insere ponto a cada 3 dígitos (1234567 => 1.234.567)
    this.cargo.quantidadeVagas = String(this.cargo.quantidadeVagas).replace(
      /^\d+/,
      function (w) {
        while (rx.test(w)) {
          w = w.replace(rx, "$1.$2");
        }
        return w;
      }
    );
  }

  async verificarNomenclatura(value) {
    const response = await cargoService.verificarNomenclatura(value);
    if (response && response.status === 400) {
      this.$bvModal.show("modal-nomenclatura");
    } else if (!response) {
      this.$toast.error("Erro ao verificar a nomenclatura.");
    }
  }

  async fecharModalLegislacoes(enviado = false) {
    if (enviado) {
      this.normativoNaoEncontrado = false;
      this.$bvModal.hide("modal-cadastro-legislacao");
      return;
    }
    const response = await cargoService.verificarNormativo(
      this.cargo.normativo.numeroAtoNormativo,
      this.cargo.normativo.anoAtoNormativo,
      this.cargo.normativo.tipoAtoNormativo
    );
    if (response && response.status != 200) {
      this.normativoNaoEncontrado = true;
    } else {
      this.normativoNaoEncontrado = false;
    }

    this.$bvModal.hide("modal-cadastro-legislacao");
  }
  mostrarInputCargaHoraria() {
    /*
        1  - AGENTE POLITICO
        2  - AGENTE PUBLICO ESPECIAL
        7  - CARGO HONORIFERO
        9  - FUNCAO DE CONFIANCA
        11 - PENSAO ESPECIAL
      */
    return (
      this.cargo.vinculo != 1 &&
      this.cargo.vinculo != 2 &&
      this.cargo.vinculo != 7 &&
      this.cargo.vinculo != 9 &&
      this.cargo.vinculo != 11 &&
      this.cargo.vinculo != null
    );
  }

  async created(): Promise<void> {
    await this.carregarTabelasAuxiliares();
    this.tiposVinculo = carregarTipoVinculo(this.tabelasAuxiliares);
    this.tiposRegimeJuridico = carregarTipoRegimeJuridico(
      this.tabelasAuxiliares
    );
    this.tiposRegimePrevidenciario = carregarTipoRegimePrevidenciario(
      this.tabelasAuxiliares
    );
    this.tiposNatureza = carregarTipoNatureza(this.tabelasAuxiliares);
    this.tiposEscolaridade = carregarTipoEscolaridade(this.tabelasAuxiliares);
    this.tiposSituacao = carregarTipoSituacao(this.tabelasAuxiliares);
    this.tiposAtoNormativo = carregarTipoAtoNormativo(this.tabelasAuxiliares);
    this.tiposVeiculoPublicacao = carregarTipoVeiculoPublicacaoNormativo(
      this.tabelasAuxiliares
    );
  }

  antigoParaSelectValue(array: any[]): SelectValue[] {
    return array.map((item: any) => {
      return {
        value: item["Id"],
        text: item["Descricao"],
      };
    });
  }
}
</script>

<style src="./css/main.css">